// extracted by mini-css-extract-plugin
export default {"singleCard":"LotRIEvs","scrollerItem":"K6WPpHo6"};